import { metricType } from "../../generic/PageUI/constants"
import { MetricUId } from "../Metrics/constants"
import getChartConfigTemplate from "./Templates/BarOrColumnChart/utils"

const GOOD_RATING_REASON_COLOR = "#198754";
const BAD_RATING_REASON_COLOR = "#E16335";

export const metricColorMap = {
  [MetricUId.ONGOING_GOOD_MEETING_RATING_REASONS]: GOOD_RATING_REASON_COLOR,
  [MetricUId.ONE_TIME_GOOD_MEETING_RATING_REASONS]: GOOD_RATING_REASON_COLOR,
  [MetricUId.ONGOING_BAD_MEETING_RATING_REASONS]: BAD_RATING_REASON_COLOR,
  [MetricUId.ONE_TIME_BAD_MEETING_RATING_REASONS]: BAD_RATING_REASON_COLOR
}

export const getMeetingRatingReasonsChartHeight = (dataCount) => {
  // TODO_GC_REPORTING_LOW: Find a way to render whole chart and use parent element to scroll instead of setting variable height
  // In case of Zero state, 300 will be the default height. Else chart height will be calculated based on data size
  return Math.max(dataCount * 60, 300);
}

export const getMeetingRatingReasonsChartConfig = (data, options={}) => {
  return getChartConfigTemplate({
    data: data,
    height: options.height,
    color: options.color,
    barPointWidth: 24,
    shouldEnableLinks: options.shouldEnableLinks,
    shouldEnableLabelLinks: true,
    showYaxisLabels: false,
    xaxisLabelsMetricType: metricType.SUBMETRIC,
    showPreviousPeriodDataLabels: false,
    exportFileName: options.exportFileName
  })
}
